module.exports = __webpack_public_path__ + "static/media/73d5b303-57a1-4ae4-a774-ef8b7a07f272.58efe5df.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/73d5b303-57a1-4ae4-a774-ef8b7a07f272.jpg
// module id = 827
// module chunks = 0